module.exports = __webpack_public_path__ + "img/chatbubbles-outline.0770432d.svg";